import CreateTeamFormPresenter from "./CreateTeamForm/CreateTeamFormPresenter";

export const CreateTeam = {
    CreateTeamForm: CreateTeamFormPresenter
}